"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardFormModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var select_field_1 = require("../../../../../components/form/select-field");
var react_2 = require("react");
var item_dropdown_1 = require("../../../../../components/form/item-dropdown");
var rewardTypeOptions = [
    { key: "xp", label: "XP Points" },
    { key: "level", label: "Level" },
    { key: "badge", label: "Badge" },
    { key: "cashback", label: "Cashback" },
];
var cashbackTypeOptions = [
    { key: "percentage", label: "Percentage" },
    { key: "fixed", label: "Fixed Amount" },
];
var RewardFormModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, onSave = _a.onSave, editReward = _a.editReward;
    var _b = (0, react_2.useState)(""), rewardType = _b[0], setRewardType = _b[1];
    var _c = (0, react_2.useState)(""), rewardValue = _c[0], setRewardValue = _c[1];
    var _d = (0, react_2.useState)("percentage"), currencyType = _d[0], setCurrencyType = _d[1];
    var _e = (0, react_2.useState)(""), currency = _e[0], setCurrency = _e[1];
    (0, react_2.useEffect)(function () {
        if (editReward) {
            setRewardType(editReward.type || "");
            setRewardValue(String(editReward.value || ""));
            setCurrencyType(editReward.currency_type || "percentage");
            setCurrency(editReward.currency || "");
        }
        else {
            setRewardType("");
            setRewardValue("");
            setCurrencyType("percentage");
            setCurrency("");
        }
    }, [editReward, isOpen]);
    var handleSave = function () {
        var reward = {
            _id: editReward === null || editReward === void 0 ? void 0 : editReward._id,
            type: rewardType,
            value: rewardValue,
        };
        if (rewardType === "cashback") {
            reward.currency_type = currencyType;
            reward.currency = currency;
        }
        onSave(reward);
        handleClose();
    };
    var handleClose = function () {
        setRewardType("");
        setRewardValue("");
        setCurrencyType("percentage");
        setCurrency("");
        onClose();
    };
    var isFormValid = function () {
        if (!rewardType || !rewardValue)
            return false;
        if (rewardType === "cashback" && (!currencyType || !currency))
            return false;
        return true;
    };
    var overlayState = (0, react_1.useOverlayState)({
        isOpen: isOpen,
        onOpenChange: function (open) {
            if (!open)
                handleClose();
        },
    });
    return ((0, jsx_runtime_1.jsx)(react_1.Modal, { state: overlayState, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Backdrop, { isDismissable: false, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Container, { size: "md", children: (0, jsx_runtime_1.jsxs)(react_1.Modal.Dialog, { children: [(0, jsx_runtime_1.jsx)(react_1.Modal.CloseTrigger, {}), (0, jsx_runtime_1.jsx)(react_1.Modal.Header, { children: (0, jsx_runtime_1.jsx)(react_1.Modal.Heading, { children: editReward ? "Edit Reward" : "Add Reward" }) }), (0, jsx_runtime_1.jsx)(react_1.Modal.Body, { children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)(select_field_1.SelectField, { label: "Reward Type", placeholder: "Select reward type", value: rewardType, onChange: function (value) { return setRewardType(value); }, isRequired: true, items: rewardTypeOptions.map(function (option) { return ({ label: option.label, value: option.key }); }) }), rewardType === "badge" ? ((0, jsx_runtime_1.jsx)(item_dropdown_1.ItemDropdown, { label: "Badge", placeholder: "Search for a badge", item_type: "badge", selected_item_ids: rewardValue ? [String(rewardValue)] : [], on_selection_change: function (itemIds) { var _a; return setRewardValue((_a = itemIds[0]) !== null && _a !== void 0 ? _a : ""); } })) : rewardType === "xp" || rewardType === "level" ? ((0, jsx_runtime_1.jsxs)(react_1.TextField, { value: rewardValue, onChange: function (value) { return setRewardValue(value); }, isRequired: true, children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: rewardType === "xp" ? "XP Points" : "Level" }), (0, jsx_runtime_1.jsx)(react_1.Input, { type: "number", placeholder: "Enter value" })] })) : rewardType === "cashback" ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(select_field_1.SelectField, { label: "Cashback Type", placeholder: "Select cashback type", value: currencyType, onChange: function (value) { return setCurrencyType(value); }, isRequired: true, items: cashbackTypeOptions.map(function (option) { return ({ label: option.label, value: option.key }); }) }), (0, jsx_runtime_1.jsxs)(react_1.TextField, { value: rewardValue, onChange: function (value) { return setRewardValue(value); }, isRequired: true, children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: currencyType === "percentage" ? "Percentage (%)" : "Amount" }), (0, jsx_runtime_1.jsx)(react_1.Input, { type: "number", placeholder: currencyType === "percentage" ? "Enter percentage" : "Enter amount" })] }), (0, jsx_runtime_1.jsxs)(react_1.TextField, { value: currency, onChange: function (value) { return setCurrency(value); }, isRequired: true, children: [(0, jsx_runtime_1.jsx)(react_1.Label, { children: "Currency Code" }), (0, jsx_runtime_1.jsx)(react_1.Input, { type: "text", placeholder: "e.g., USD, GBP" })] })] })) : null] }) }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Footer, { children: [(0, jsx_runtime_1.jsx)(react_1.Button, { variant: "tertiary", onPress: handleClose, children: "Cancel" }), (0, jsx_runtime_1.jsx)(react_1.Button, { variant: "primary", onPress: handleSave, isDisabled: !isFormValid(), children: editReward ? "Update" : "Add" })] })] }) }) }) }));
};
exports.RewardFormModal = RewardFormModal;
